import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Widget from '../../../Widget'
import ShortcodeOption from './Option'
import Copy from '../Hotsheets/Copy'
import Icon from '../../../icon'

@inject('websites')
@observer
export default class ShortcodeGenerator extends Component {
  website = this.props.websites.current

  state = {
    query: this.props.defaults || {}
  }

  buildShortcode() {
    const { shortcodeName } = this.props
    const { query } = this.state

    const pairs = []
    for (const key of Object.keys(query)) {
      let val = query[key]
      if (Array.isArray(val)) {
        val = val.join(',')
      }
      pairs.push(`${key}="${val}"`)
    }

    const qrystr = pairs.length ? ` ${pairs.join(' ')}` : ''

    return `[showcaseidx_${shortcodeName}${qrystr}]`
  }

  buildQuery() {
    const query = {
      ...this.state.query,
      website_uuid: this.website.uuid,
    }

    const pairs = []
    for (const key of Object.keys(query)) {
      const val = query[key]
      if (Array.isArray(val)) {
        for (const item of val) {
          pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
        }
      } else {
        pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
      }
    }

    return `?${pairs.join('&')}`
  }

  renderOptions() {
    const { options } = this.props
    if (options) {
      return Object.keys(options).map(name => (
        <ShortcodeOption
          key={name}
          query={this.state.query}
          onChange={query => this.setState({ query })}
          name={name}
          {...options[name]} />
      ))
    }
  }

  render() {
    const { widget } = this.props
    const shortcode = this.buildShortcode()
    const options = this.renderOptions()
    return (
      <div>
        <h3 className="title">Shortcode</h3>
        <strong>{shortcode}</strong> <Copy key={shortcode} text={shortcode} />
        <br />
        <br />
        {options && (
          <span>
            <h3 className="title">Options</h3>
            {options}
            <br />
            <br />
          </span>
        )}
        <h3 className="title">Preview</h3>
        <div style={{ pointerEvents: "none", height: "55px" }}>
          <Widget
            width="100%"
            src={`${widget}${this.buildQuery()}`}
            dynamicHeight
          />
        </div>
        {shortcode.includes("pills") && (
          <div className="sidx-pills-container">
            <div className="sidx-pills">
              <div>
                <div className="sidx-pills-value" style={{}}>
                  123432
                </div>
                <div className="sidx-pills-category" style={{}}>
                  MLS Number
                </div>
              </div>
               <Icon symbol="times" onClick={() => {}}/>
            </div>
            <div className="sidx-pills">
              <div>
                <div className="sidx-pills-value">2+ Beds</div>
                <div className="sidx-pills-category">Beds</div>
              </div>
              <Icon symbol="times" onClick={() => {}}/>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Shortcodes/Generator.js